import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=b2385198&scoped=true&"
import script from "./DetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=b2385198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2385198",
  null
  
)

export default component.exports